import { z } from 'zod';
import { AloftObject } from './AloftObject.js';
/** @deprecated - Use schPositiveInt instead */
const schAloftCountJSON = z.object({ $type: z.literal('AloftCount'), value: z.number() });
/** @deprecated - Use PositiveInt instead */
export class AloftCount extends AloftObject {
    value;
    constructor(value) {
        super();
        this.value = value;
    }
    static isAloftCount(x) {
        return x instanceof AloftCount;
    }
    compare(that) {
        return this.value - that.value;
    }
    // NOTE: toJSON() and schema.parse() should be inverses of each other!
    toJSON() {
        return { $type: 'AloftCount', value: this.value };
    }
    static schema = z
        .union([schAloftCountJSON, z.custom((x) => x instanceof AloftCount)])
        .transform(({ value }) => new AloftCount(value));
    static zero = new AloftCount(0);
    toNumber() {
        return this.value;
    }
    static fromNumber(n) {
        if (n === null || n === undefined)
            return n;
        if (!Number.isInteger(n)) {
            throw new Error(`Failed to construct AloftCount: ${n} is not an integer`);
        }
        if (n < 0) {
            throw new Error(`Failed to construct AloftCount: ${n} is less than 0`);
        }
        return new AloftCount(n);
    }
    toString() {
        return `${this.value}`;
    }
    add(that) {
        if (that === undefined || that === null)
            return this;
        return AloftCount.fromNumber(this.value + that.value);
    }
    static add(...counts) {
        return AloftCount.fromNumber(counts.reduce((a, b) => a + b.value, 0));
    }
    static addWithNulls(...counts) {
        return counts.reduce((a, b) => a?.add(b) ?? b ?? null, null);
    }
}
//# sourceMappingURL=AloftCount.js.map